import {
  Box,
  Button,
  Spacer,
  Spinner,
  Text,
  useUpdateEffect,
} from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import useFilterChartData from 'hooks/modules/chart/userFilterChart';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import IncomeChartLoaded from 'presentation/components/modules/incomeChart/IncomeChartLoaded';
import PortfolioBalanceInfo from 'presentation/components/modules/portfolio/PortfolioBalanceInfo';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import {
  useFetchPortfolioQuery,
  useLazyFetchPortfolioShortQuery,
} from 'rtkQuery/sharespro/queries/portfolio';
interface Props {
  isReportable: boolean;
  id: number;
}
const PortfolioChartContainer: FC<Props> = ({ isReportable, id }) => {
  const [period, setPeriod] = usePeriodQueryParam();
  const [accountId] = useAccountIdQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });
  const [trigger, chartResult] = useLazyFetchPortfolioShortQuery();

  useUpdateEffect(() => {
    trigger({ period, account_id: accountId });
  }, [period]);

  const { t } = useTranslation();

  const filterChartData = useFilterChartData;

  const navigate = useNavigate();

  let content;
  if (data) {
    const filteredChartData = filterChartData(data.chart.chartData);

    if (filteredChartData.length > 1) {
      content = (
        <Box w="100%">
          <IncomeChartLoaded
            data={{ ...data.chart, chartData: filteredChartData }}
            onPeriodClick={(period) => setPeriod(period)}
            isDataFetching={chartResult.isFetching || isFetching}
            selectedPeriod={period}
            onRefetch={() => {
              refetch();
            }}
            error={error}
            period={period}
          />
          <Spacer h="20px" />
          <PortfolioBalanceInfo {...data.balanceInfo} />
          <Spacer h="20px" />
          {isReportable && (
            <Button onClick={() => navigate(AppRoute.createReportDetail(id))}>
              {t('downloadReport')}
            </Button>
          )}
        </Box>
      );
    } else {
      content = (
        <Text textAlign="center">{t('portfolioChartDataIsEmpty')}</Text>
      );
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <>
      <GridHeading>{t('incomeChartTitle')}</GridHeading>
      <AppCard
        p="20px"
        minH="320px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {content}
      </AppCard>
    </>
  );
};

export default PortfolioChartContainer;
